<template>
    <div class="group" :class="{ [`group-color_${value.color}`]: !!value.color }">
        <div class="group__header">
            <svg width="16" height="16">
                <use :href="value.icon"></use>
            </svg>
            <div class="group__title">
                {{ value.name }}
            </div>
            <div class="group__status">
                {{ value.status }}
            </div>
        </div>
        <div class="group__list gap-12">
            <v-item v-for="item in value.value" :key="item.id" :value="item" />
        </div>
    </div>
</template>

<script>
    import vItem from './item.vue'
    export default {
        props: {
            value: {
                type: Object,
                default: false
            }
        },
        components: {
            vItem
        }
    }
</script>

